import { AxiosResponse } from 'axios';
import { throttle } from '../config';
import { PaginationAndFilter } from '../interfaces/common/pagination';
import type { Pincode } from '../interfaces/masters/pincode/pincode';
import { wait } from '../utils/wait';
import axiosClient from '../utils/axios-client';

class PincodeApi {
  // calls api to add pincodes in the database
  async addPincodes(pincodes: number[]): Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient.post('master/pincodes', pincodes).then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  // calls put api to update pincode
  async updatePincode(pincode: Pincode): Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient.put('master/pincodes', pincode).then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async getPincodesByPaginationAndFilters(options: PaginationAndFilter):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient.post('master/pincodes/getByPaginationAndFilter', options).then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async getPincodesFilterData():Promise<AxiosResponse> {
    if (throttle) {
      await wait(throttle);
    }

    const response = await axiosClient.get('master/pincodes/filtersData');
    return response;
  }

  async getDistinctValues(inputOption: any):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient.get('master/pincodes/distinct', { params: inputOption })
        .then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }
}

export const pincodeApi = new PincodeApi();
